<template>
  <svg width="20"
       height="14"
       viewBox="0 0 20 14"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M2.16016 2.50586C2.85449 2.50586 3.4082 1.95215 3.4082 1.25781C3.4082 0.572266 2.85449 0.00976562 2.16016 0.00976562C1.47461 0.00976562 0.912109 0.572266 0.912109 1.25781C0.912109 1.95215 1.47461 2.50586 2.16016 2.50586ZM6.29102 2.10156H18.2266C18.7012 2.10156 19.0791 1.73242 19.0791 1.25781C19.0791 0.783203 18.71 0.414062 18.2266 0.414062H6.29102C5.8252 0.414062 5.44727 0.783203 5.44727 1.25781C5.44727 1.73242 5.81641 2.10156 6.29102 2.10156ZM2.16016 7.91113C2.85449 7.91113 3.4082 7.35742 3.4082 6.66309C3.4082 5.97754 2.85449 5.41504 2.16016 5.41504C1.47461 5.41504 0.912109 5.97754 0.912109 6.66309C0.912109 7.35742 1.47461 7.91113 2.16016 7.91113ZM6.29102 7.50684H18.2266C18.7012 7.50684 19.0791 7.1377 19.0791 6.66309C19.0791 6.18848 18.71 5.81934 18.2266 5.81934H6.29102C5.8252 5.81934 5.44727 6.18848 5.44727 6.66309C5.44727 7.1377 5.81641 7.50684 6.29102 7.50684ZM2.16016 13.3164C2.85449 13.3164 3.4082 12.7627 3.4082 12.0684C3.4082 11.3828 2.85449 10.8203 2.16016 10.8203C1.47461 10.8203 0.912109 11.3828 0.912109 12.0684C0.912109 12.7627 1.47461 13.3164 2.16016 13.3164ZM6.29102 12.9121H18.2266C18.7012 12.9121 19.0791 12.543 19.0791 12.0684C19.0791 11.5938 18.71 11.2246 18.2266 11.2246H6.29102C5.8252 11.2246 5.44727 11.5938 5.44727 12.0684C5.44727 12.543 5.81641 12.9121 6.29102 12.9121Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 13
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
